<script>
    export let name;
    export let value;
    export let required;

    export let multiple;
    export let field_class;

    let options = [
        "High",
        "Medium",
        "Low"
    ]
</script>

{#if multiple}
    <div class="select is-fullwidth {field_class} is-multiple">
        <select {name} {required} bind:value={value} multiple on:change on:blur>
            {#each options as option}
                <option value={option}>
                    {option}
                </option>
            {/each}
        </select>
    </div>
    {:else}
    <div class="select is-fullwidth {field_class}">
        <select {name} {required} bind:value={value} on:change on:blur>
            {#each options as option}
                <option value={option}>
                    {option}
                </option>
            {/each}
        </select>
    </div>
{/if}
